// app/directives/icon-init.directive.ts
import { Directive } from '@angular/core';
import { IconSetService } from '@coreui/icons-angular';
import { iconSubset } from '../icons/icon-subset';

@Directive({
    selector: '[appIconInit]',
    standalone: true
})
export class IconInitDirective {
    constructor(iconService: IconSetService) {
        iconService.icons = { ...iconSubset };
    }
}
